import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import Index from "./index";
import Edit from "./edit";

export default class Base extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/infoitems" component={Index}/>
                    <Route path="/infoitems/create" component={Edit}/>
                    <Route path="/infoitems/:id" component={Edit}/>
                </Switch>
        )
    }
}
